export enum WoundDescriptionType {
  WHITE = 'WHITE',
  ROSY = 'ROSY',
  REDDENED = 'REDDENED',
  WET = 'WET',
  DRY = 'DRY',
  SOFT = 'SOFT',
  HARD = 'HARD',
  FIRM = 'FIRM',
  ROSE = 'ROSE',
  RED = 'RED',
  YELLOW = 'YELLOW',
  LITTLE = 'LITTLE',
  MUCH = 'MUCH',
  CLEAR = 'CLEAR',
  SERIOUS = 'SERIOUS',
  BLOODY = 'BLOODY',
  PARTIALLY = 'PARTIALLY',
  COMPLETE = 'COMPLETE',
}

// export enum SurroundingSecond {
//   wet = 'WET',
//   dry = 'DRY',
// }

// export enum BorderFirst {
//   rosy = 'ROSY',
//   reddened = 'REDDENED',
// }

// export enum BorderSecond {
//   soft = 'ROSY',
//   tender = 'REDDENED',
// }

// export enum BorderThird {
//   rosy = 'ROSY',
//   reddened = 'REDDENED',
// }

// export enum BorderFourth {
//   rosy = 'ROSY',
//   reddened = 'REDDENED',
// }
